import { zhContent } from "./zh";

// English content intentionally reuses the Chinese source as a placeholder.
// Do not machine-translate or rewrite marketing/legal copy here. Human-provided
// English text should replace field values while preserving this structure.
export const enContent = zhContent;
